<p-dialog
  header="Add Attachment"
  [dismissableMask]="true"
  [(visible)]="isModalVisible"
  [modal]="true"
  [style]="{ width: '600px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="handleModalHide()"
>
  <app-upload-file
    [form]="fileForm"
    title="Upload Attachment"
    controlName="file"
  ></app-upload-file>
  <ng-template pTemplate="footer">
    <div class="footer-buttons">
      <button
        [disabled]="!fileForm.valid"
        (click)="toggleModal()"
        class="cancel-btn"
      >
        Cancel
      </button>
      <button
        [disabled]="!fileForm.valid"
        (click)="handleSubmit()"
        class="custom-btn"
      >
        Confirm
      </button>
    </div>
  </ng-template>
</p-dialog>
